/* global $ */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';
import axiosInstance from '../axiosInstance';

function SeizedVehicle() {
    const defaultRecord = {
        id: "",
        finance_id: "",
        reg_no: "",
        name: "",
        loan_amount: "",
        emi_amount: "",
        tenure_months: "",
        seized_date: "",
        seizing_charges: "",
        seized_by: "",
        created_by: localStorage.getItem('user_id') || ""
    };

    const [newRecord, setNewRecord] = useState(defaultRecord);
    const [registrations, setRegistrations] = useState([]);
    const [users, setUsers] = useState([]);
    const [errors, setErrors] = useState({
        reg_no: "",
        seized_date: "",
        seized_by: "",
    });
    const [vehicleData, setVehicleData] = useState([]);

    const fetchFinanceAndUsers = async () => {
        try {
            const financeRes = await axiosInstance.get('/finance/seized');
            //console.log("FinanceRoll : ", financeRes);
            setRegistrations(financeRes.data);
            const userRes = await axiosInstance.get('/user/nosuperadmin');
            //console.log("userdetails : ", userRes.data);
            // Handle both possible response shapes
            const usersArray = Array.isArray(userRes.data) ? userRes.data : userRes.data.data || [];

            // Filter out superadmin (usertype = 1)
            const filteredUsers = usersArray.filter(user => user.usertype !== 1);

            setUsers(filteredUsers);

            //console.log("Users for dropdown:", filteredUsers);
        } catch (error) {
            console.error(error);
            setRegistrations([]);
            setUsers([]);
        }
    };

    const fetchSeizedVehicles = async () => {
        try {
            const res = await axiosInstance.get('/seizedvehicle/');
            //console.log("Seized Details: ", res.data.data)
            setVehicleData(res.data.data);
        } catch (err) {
            console.error('Error loading seized vehicles:', err);
            setVehicleData([]);
        }
    };

    useEffect(() => {
        fetchFinanceAndUsers();
        fetchSeizedVehicles();
    }, []);


    // Validation function
    const validateForm = () => {
        let formErrors = {}; // Store validation errors

        // Check if required fields are empty (if a field is required, you can add custom logic here)
        if (!newRecord.reg_no) {
            formErrors.reg_no = "Registration Number is required";
        }

        if (!newRecord.seized_date) {
            formErrors.seized_date = "Seized Date is required";
        }

        if (!newRecord.seized_by) {
            formErrors.seized_by = "Seized by is required";
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewRecord(prev => ({ ...prev, [name]: value }));

        if (name === 'reg_no') {
            const selected = registrations.find(item => item.reg_no === value);
            if (selected) {
                setNewRecord(prev => ({
                    ...prev,
                    finance_id: selected.id,
                    name: selected.borrower_name,
                    loan_amount: selected.loan_amount,
                    emi_amount: selected.emi_amount,
                    tenure_months: selected.tenure_months,
                    created_by: localStorage.getItem('user_id')
                }));
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setErrors({});
            try {
                const response = await axiosInstance.post('/seizedvehicle/add', newRecord);
                Swal.fire('Success', response.data.message, 'success');
                setNewRecord(defaultRecord);
                fetchSeizedVehicles(); // ✅ Refresh the data
                fetchFinanceAndUsers();
            } catch (err) {
                Swal.fire('Error', err.response?.data?.message || 'Failed to save data', 'error');
            }
        }
    };

    // Delete function
    const handleDelete = async (vehicleId, regNo, issizzed) => {
        try {

            // Check if vehicle is still seized
            if (issizzed == 1 || issizzed == true) {
                // Show alert to release vehicle first
                Swal.fire({
                    title: 'Cannot Delete!',
                    text: 'Please release the vehicle first in the Finance tab before deleting the seized vehicle record.',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return; // Exit the function
            }

            // Show confirmation dialog
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: `Do you want to delete seized vehicle ${regNo}? This action will also update the finance record.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!'
            });

            if (result.isConfirmed) {
                // Make delete request
                const response = await axiosInstance.delete(`/seizedvehicle/${vehicleId}`, {
                    data: {
                        modified_by: parseInt(localStorage.getItem('user_id')) || 0
                    }
                });

                // Show success message
                Swal.fire({
                    title: 'Deleted!',
                    text: response.data.message,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });

                // Refresh the data
                fetchSeizedVehicles();
            }
        } catch (err) {
            console.error('Delete error:', err);
            Swal.fire({
                title: 'Error!',
                text: err.response?.data?.message || 'Failed to delete the seized vehicle',
                icon: 'error'
            });
        }
    };

    // Add this function to handle releasing seized vehicle
    const handleRelease = async (regNo, financeId, seizedId) => {
        try {
            const modified_by = localStorage.getItem('user_id');

            const result = await Swal.fire({
                title: 'Release Seized Vehicle?',
                text: `Are you sure you want to release the seized vehicle ${regNo}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, release it!',
                cancelButtonText: 'Cancel'
            });

            if (result.isConfirmed) {
                // Update finance record
                const response = await axiosInstance.put(`/finance/${financeId}`, {
                    issizzed: false,
                    modified_by
                });

                // Delete seized vehicle record
                const sizzedresponse = await axiosInstance.delete(`/seizedvehicle/finance/${financeId}`, {
                    data: { modified_by }
                });

                if (response.status === 200 && sizzedresponse.status === 200) {
                    Swal.fire({
                        title: 'Released!',
                        text: 'The seized vehicle has been released successfully.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    fetchSeizedVehicles();
                }

            }
        } catch (err) {
            console.error('Release error:', err);
            Swal.fire({
                title: 'Error!',
                text: err.response?.data?.message || 'Failed to release the seized vehicle',
                icon: 'error'
            });
        }
    };


    const columns = [
        { name: 'Reg No', selector: row => row.reg_no, sortable: true },
        { name: 'Name', selector: row => row.name },
        { name: 'Loan Amount', selector: row => row.loan_amount },
        { name: 'EMI Amount', selector: row => row.emi_amount },
        { name: 'Tenure Months', selector: row => row.tenure_months },
        { name: 'Seized By', selector: row => row.seized_by_vehicle.username },
        {
            name: 'Seized Date',
            selector: row => {
                if (!row.seized_date) return "";
                const d = new Date(row.seized_date);
                return d.toLocaleDateString("en-GB"); // "18/09/2025"
            }
        },
        { name: 'Seizing Charges', selector: row => row.seizing_charges },
        {
            name: 'Action',
            cell: row => (
                <button
                    className="btn btn-sm btn-warning"
                    onClick={() => handleRelease(row.reg_no, row.finance_id, row.id)}
                    title="Release Vehicle"
                >
                    Release
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        }
    ];

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Seized Vehicle</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Seized Vehicle</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-3">
                <div className="card shadow">
                    <div className="card-header bg-dark text-white">
                        <h4>Add Seized Vehicle</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label>Registration No</label>
                                    <select className="form-control" name="reg_no" value={newRecord.reg_no} onChange={handleInputChange}>
                                        <option value="">Select</option>
                                        {registrations.map((item) => (
                                            <option key={item.id} value={item.reg_no}>{item.reg_no}</option>
                                        ))}
                                    </select>
                                    {errors.reg_no && <small className="text-danger">{errors.reg_no}</small>}
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label>Name</label>
                                    <input className="form-control" value={newRecord.name} name="name" readOnly />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label>Loan Amount</label>
                                    <input className="form-control" value={newRecord.loan_amount} name="loan_amount" readOnly />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label>EMI Amount</label>
                                    <input className="form-control" value={newRecord.emi_amount} name="emi_amount" readOnly />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label>Tenure Months</label>
                                    <input className="form-control" value={newRecord.tenure_months} name="tenure_months" readOnly />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label>Seized Date</label>
                                    <input type="date" className="form-control" name="seized_date" value={newRecord.seized_date} onChange={handleInputChange} />
                                    {errors.seized_date && <small className="text-danger">{errors.seized_date}</small>}
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label>Seizing Charges</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="seizing_charges"
                                        value={newRecord.seizing_charges || ""}
                                        onChange={(e) =>
                                            setNewRecord({
                                                ...newRecord,
                                                seizing_charges: e.target.value ? parseFloat(e.target.value) : null,
                                            })
                                        }
                                    />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label>Seized By</label>
                                    <select className="form-control" name="seized_by" value={newRecord.seized_by} onChange={handleInputChange}>
                                        <option value="">Select</option>
                                        {users.map((u) => (
                                            <option key={u.id} value={u.id}>{u.username}</option>
                                        ))}
                                    </select>
                                    {errors.seized_by && <small className="text-danger">{errors.seized_by}</small>}
                                </div>
                            </div>
                            <button className="btn btn-success" type="submit">Save</button>
                        </form>
                    </div>
                </div>

                <div className="card mt-4 shadow">
                    <div className="card-header bg-dark text-white">
                        <h4>Seized Vehicle List</h4>
                    </div>
                    <div className="card-body">
                        <DataTable
                            columns={columns}
                            data={vehicleData}
                            pagination
                            highlightOnHover
                            responsive
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SeizedVehicle;